<template>
  <div>
    <div class="mt-5">
      <vs-tabs>
        <vs-tab label="TRACKING">
          <div class="tab-text">
            <vx-card
              title="TRACKING SETTINGS"
              collapse-action
              class="overflow-hidden"
            >
              <div class="vx-row">
                <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
                  <h6 class="mt-2">Geofence radius (default)</h6>
                </div>
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <vs-slider
                    ticks
                    step="10"
                    :step-decimals="false"
                    max="100"
                    text-fixed="mi"
                    v-model="value3"
                  />
                </div>
              </div>
              <div style="float: right" class="mb-5">
                <vs-button color="primary" class="mr-5" type="border"
                  >CANCEL</vs-button
                >
                <vs-button color="primary" type="filled">OK</vs-button>
              </div>
            </vx-card>
          </div>
        </vs-tab>
        <vs-tab label="E-Log">
          <div class="tab-text">
            <vx-card
              title="AOBRD SETTINGS"
              collapse-action
              class="overflow-hidden"
            >
              <div class="vx-row">
                <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
                  <h6 class="mt-2">Trigger Driving Event Speed</h6>
                </div>
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <vs-slider ticks max="25" text-fixed="mph" v-model="value3" />
                </div>
              </div>
              <h6 style="color: #eb212d" class="mb-3 mt-5">
                DOT recommends settings of 19 MPH or less
              </h6>
              <div style="float: right" class="mb-5">
                <vs-button color="primary" class="mr-5" type="border"
                  >CANCEL</vs-button
                >
                <vs-button color="primary" type="filled">OK</vs-button>
              </div>
            </vx-card>
          </div>
        </vs-tab>
        <vs-tab label="FLEET SETTINGS">
          <div class="tab-text">
            <vx-card
              title="FLEET SETTINGS"
              collapse-action
              class="overflow-hidden"
            >
              <div style="display: flex; margin-left: 25%">
                <h6>Allow Split Sleeper Berth</h6>
                <vs-checkbox v-model="checkBox1">Primary</vs-checkbox>
              </div>
              <div style="float: right" class="mb-5 mt-4">
                <vs-button color="primary" class="mr-5" type="border"
                  >CANCEL</vs-button
                >
                <vs-button color="primary" type="filled">OK</vs-button>
              </div>
            </vx-card>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value3: 5,
      checkBox1: "ncxienjciej",
    };
  },
};
</script>
